import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'instanciaLetra',
  type: 'node--instancia_letra',
  attributes: {
    valor: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'valor',
    },
    valorCesion: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'valor_en_cesion',
    },
  },
  relationships: {
    letra: {
      type: 'taxonomy_term--letra',
      required: false,
      isArray: false,
      name: 'tipo_letra',
    },
  },
};

export const InstanciaLetraService = createService(base, configuration, API_CONFIG.API);
export const InstanciaLetraModule = createModule(InstanciaLetraService, true);



// WEBPACK FOOTER //
// ./src/models/instanciaLetra.js